<template>
  <div id="login">
    <v-layout>
      <v-flex
        xs12
        sm4
        offset-sm4
      >
        <v-card>
          <v-card-title
            primary-title
            class="grey lighten-4"
          >
            <h1 class="title mt-0 mb-0">
              {{ titleText }}
            </h1>
          </v-card-title>
          <v-divider light />
          <v-card-text>
            <StateFlow
              :activation-code="sac"
              :auto-login="state === 'login'"
              :display-title="false"
              :init="state"
              @title="value => { titleText = value }"
              @change-state="(value) => {state = value}"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import snThemeMixin from '../common/snThemeMixin'
import statefulAuth from '../common/_statefulAuth.vue'

export default {
  name: 'Login',

  components: {
    StateFlow: statefulAuth
  },

  mixins: [snThemeMixin],

  props: {
    hiddenFooter: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      autofocus: false,
      state: 'login',
      titleText: 'Welcome',
      buttonColor: '#003a5d',
      sacId: '',
      sac: ''
    }
  },

  created () {
    // Servicer Activation Code (borrower pages only)
    if (window.location.pathname.includes('/borrower/')) {
      const SAC = /\/(?!borrower)(?!login)([^/]*)[/]?$/i.exec(window.location.pathname)

      // Assign SAC if valid
      if (SAC) {
        this.sac = SAC[1]
      }
    }

    if (window.location.href.includes('fairway')) {
      this.buttonColor = '#034d3d'
    }

    this.autofocus = true
  },

  methods: {
    callActionFunction (action) {
      switch (action) {
        case 'start':
          this.state = 'start'
          break
        case 'request_sign_in':
          this.titleText = 'Log In'
          this.state = 'statefulAuth'
          break
      }
    }
  }
}
</script>

<style>
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
  }
</style>

<style scoped>
  .container {
    padding-top: 0px;
    padding: 0;
    margin: 0 auto;
  }
</style>

<style scoped>
  .checkbox label, .radio label {
    padding-left: 0;
    margin-left: 30px;
  }

  .input-group__details:before {
    background-color: darkgrey;
  }

  .container-fluid {
    width: 100%;
  }
/*
  .nav.pull-right {
    margin-right: 10% !important;
  } */

  /* .brand {
    margin-left: 7% !important;
  } */

  .btn-outline {
    display: unset !important;
    top: 14px;
  }
/*
  @media screen and (-webkit-min-device-pixel-ratio:0) {
    .navbar {
      height: auto !important;
    }
  } */
</style>

<style scoped>
  a {
    cursor: pointer;
  }

  h6 {
    margin-bottom: 0;
  }

  .card__title {
    padding-top: 10px;
    padding-bottom: 5px;
  }

  .divider {
    /*background-color: rgb(51, 51, 51);*/
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .input-group {
    padding-bottom: 0px;
  }

  .login-footer {
    text-align: center;
    margin-top: 10px;
  }

  .login-footer p {
    margin-bottom: 0;
  }

  .checkbox label {
    margin-left: 10px !important;
  }

</style>
